import React, { Fragment, useEffect } from 'react'
import { QrReader } from 'react-qr-reader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMachinesByLineArea } from '../equipment/equipmentApi';
import { Stack, Container, Button } from 'react-bootstrap';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { resetQR, resetSearch, writeConfirmedMachineFromCurrent } from '../equipment/equiplmentSlice';

function Scanner(props) {
    const [isFind, setIsFind] = useState(false)
    const [isRotate, setIsRotate] = useState(false)
    const equipment = useSelector((state) => state.equipment)
    const login = useSelector((state) => state.login)
    const dispatch = useDispatch()

    let navigate = useNavigate();
    useEffect(() => {
        if (!login.token) {
            return navigate("/login");
        }
    })
    useEffect(() => {
        if (isFind) {
            dispatch(resetQR())
            return navigate("/anomaly");
        }
    })
    let info = (<Fragment>

        <p>Не найдено оборудование</p>
        <Button variant="outline-secondary" as={Link} to="/anomaly" className="me-10">Вернуться к регистрации аномалии </Button>
    </Fragment>)
    function onRestartSearch() {
        dispatch(resetQR())
        dispatch(resetSearch())
        setIsFind(false)
    }
    function onFindMachine(machine) {
        dispatch(writeConfirmedMachineFromCurrent())
        dispatch(resetSearch())
        setIsFind(true)
    }
    if (equipment.isQr) {
        return (<Stack gap={4} className="col-md-6 mx-auto">
            <p>Найдено оборудование: {equipment.currentMachine}</p>

            <Button variant="primary" onClick={() => onFindMachine(equipment.currentMachine)} className="me-10">Подтвердить </Button>
            <Button variant="outline-secondary" onClick={() => onRestartSearch()} className="me-10">Повторить поиск </Button>
        </Stack>)
    }

    function handleScan(data) {
        if (data) {
            console.log('before parsing!!')
            try {
                data = JSON.parse(data);
            } catch (e) {
                toast.error('Нет информации об оборудовании!', {
                    position: "bottom-left",
                    autoClose: 1000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                return
            }

            console.log("after parsing")
            console.log(data)
            data.token = login.token
            dispatch(getMachinesByLineArea(data))
        }
    };
    function handleError(err) {
        toast.error('Ошибка распознавания QR!', {
            position: "bottom-left",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        });
    };

    let camera = (<Fragment></Fragment>)
    function onRotateCamera() {
        if (isRotate) {
            setIsRotate(false)
        } else {
            setIsRotate(true)
        }
    }
    if (isRotate) {
        const videoConstraints = {
            width: 720,
            height: 720,
            facingMode: "user"
        };
        camera = (<QrReader
            key={"environment"}
            constraints={videoConstraints}
            delay={300}
            onResult={handleScan}
            onError={handleError}
            onScan={handleScan}
        />)
    } else {
        console.log('URA!!')
        const videoConstraints = {
            width: 720,
            height: 720,
            facingMode: { exact: "environment" }
        };
        camera = (<QrReader
            key={"user"}
            constraints={videoConstraints}
            delay={300}
            onResult={handleScan}
            onError={handleError}
            onScan={handleScan}
        />)
    }
    //let c = { facingMode: { exact: "user" }, height: { exact: 50 }, width: { exact: 50 } };
    return (
        <Stack gap={4} className="col-md-6 mx-auto">
            <Container >
                {camera}
            </Container>
            <Fragment>{info}</Fragment>
            <Button variant="outline-secondary" onClick={() => onRotateCamera()} className="me-10">Изменить камеру </Button>
        </Stack>

    );

}

export default Scanner;
